import React, { ReactNode } from "react";
import { createPortal } from "react-dom";
import { GrFormClose } from "react-icons/gr";

type Props = {
  open: boolean;
  close?: () => void;
  children: ReactNode;
};

// Portalled to <body> so a modal opened from inside a table cell or other
// stacking context isn't trapped under the sticky Navbar (z-40).
const ModalContainer = ({ open, close, children }: Props) => {
  return createPortal(
    <div
      className={`z-50 fixed inset-x-0 -top-10 bottom-0 w-full items-center justify-center overflow-auto bg-black/60 ${
        open ? "flex" : "hidden"
      }`}
    >
      <section
        className={`relative z-20 flex flex-col space-y-3 overflow-hidden rounded-lg bg-white px-2 py-5`}
      >
        <div
          onClick={close}
          className="absolute z-10 right-5 top-5 block hover:cursor-pointer"
        >
          <GrFormClose className="h-6 w-6" />
        </div>

        {children}
      </section>
    </div>,
    document.body
  );
};

export default ModalContainer;
